<div class="container" [dir]="rtl ? 'rtl' : 'ltr'">
  <div *ngIf="loadings$ | async as loading">
    <div
      *ngIf="loading?.placing"
      [attr.data-tid]="'cmx-createoneclickorder-singleprofile-btnexit'"
      class="close-btn custom-dialog-container__close disabled"
    >
      <span class="cmx-icon-close"></span>
    </div>
    <div
      *ngIf="!loading?.placing"
      [attr.data-tid]="'cmx-createoneclickorder-singleprofile-btnexit'"
      (click)="cancel()"
      class="close-btn custom-dialog-container__close"
    >
      <span class="cmx-icon-close"></span>
    </div>
  </div>

  <!-- Result modal -->
  <div *ngIf="result" class="container-fluid">
    <div class="container-layout center-text">
      <ng-container>
        <div>
          <span
            [ngClass]="{
              'cmx-icon-check-rounded-active-fill': result.icon === OrderCreationIcon.Success,
              'cmx-icon-warning-rounded-fill': result.icon === OrderCreationIcon.Warning
            }"
            aria-hidden="true"
            [attr.data-tid]="'cmx-createoneclickorder-icnresult'"
          >
          </span>
          <div class="message-text">
            <span [attr.data-tid]="'cmx-createoneclickorder-lblresultmessage'" *ngIf="result.message">
              {{ result.message }}
            </span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="!result" data-tid="cmx-createoneclickorder-singleprofile-lblmaintitle" class="font-title">
    {{ 'views.one_click.order' | translate }} {{ selectedProductLineProfile ? ' - ' + selectedProductLineProfile : '' }}
  </div>

  <app-one-click-multiple-selection *ngIf="orders?.length > 1 && !isFromTable"></app-one-click-multiple-selection>

  <app-one-click-order-preview
    *ngIf="orderSelected$ | async"
    (ready)="setReadyToOrder($event)"
  ></app-one-click-order-preview>

  <div class="actions" *ngIf="isValidOrder">
    <cwc-button
      class="action-button"
      [attr.data-tid]="'cmx-createoneclickorder-singleprofile-btncancel'"
      *ngIf="!result"
      (cwcClick)="cancel()"
      [disabled]="(loadings$ | async)?.placing"
      [variant]="'support'"
      designVersion="v2"
    >
      {{ 'views.common.cancel' | translate }}
    </cwc-button>
    <cwc-button
      class="action-button"
      [attr.data-tid]="'cmx-createoneclickorder-singleprofile-btnback'"
      (cwcClick)="reset()"
      [variant]="'support'"
      *ngIf="!result && (orderSelected$ | async) && !isFromTable && orders?.length > 1"
      [disabled]="(loadings$ | async)?.placing"
      designVersion="v2"
    >
      {{ 'views.common.back' | translate }}
    </cwc-button>
    <cwc-button
      class="action-button"
      [attr.data-tid]="'cmx-createoneclickorder-singleprofile-btnsubmit'"
      *ngIf="!result"
      (cwcClick)="submit()"
      [disabled]="(shouldDisableSubmitButtonFlag | async) || !isReadyToOrder"
      [variant]="'primary'"
      designVersion="v2"
    >
      <ng-container *ngIf="(loadings$ | async)?.placing"> {{ 'views.common.placing' | translate }}... </ng-container>
      <ng-container *ngIf="!(loadings$ | async)?.placing">{{ 'global.submit' | translate }}</ng-container>
    </cwc-button>
    <cwc-button
      *ngIf="!(loadings$ | async)?.placing && result"
      (cwcClick)="navigateToOrders()"
      [variant]="'support'"
      [attr.data-tid]="'cmx-createoneclickorder-singleprofile-btnbacktoorders'"
      designVersion="v2"
    >
      {{ 'views.common.back_orders' | translate }}
    </cwc-button>
  </div>
  <div class="actions" *ngIf="!isValidOrder && isLoading">
    <cwc-button
      [attr.data-tid]="'cmx-createoneclickorder-singleprofile-btncancel'"
      *ngIf="!result"
      (cwcClick)="cancel()"
      [disabled]="(loadings$ | async)?.placing"
      designVersion="v2"
    >
      {{ 'view.one_click.accept.button' | translate }}
    </cwc-button>
  </div>
</div>
